import { type ComponentProps } from "react"
import { useNavigate } from "@tanstack/react-router"

import { api } from "@/api"
import { useAuth } from "@/store/auth"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

export function SignOutConfirmation(props: ComponentProps<typeof AlertDialog>) {
  const auth = useAuth()
  const navigate = useNavigate()

  const onSignOut = async () => {
    const { refreshToken } = useAuth.getState()
    if (refreshToken) {
      try {
        await api.POST("/auth/staff/logout/", { body: { refresh: refreshToken } })
      } catch {
        // token already expired or invalid — proceed with local sign-out anyway
      }
    }
    auth.signOut()
    void navigate({ to: "/sign-in" })
  }

  return (
    <AlertDialog {...props}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Sign Out</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          Are you sure you would like to sign out?
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction variant={"destructive"} onClick={() => void onSignOut()}>
            Sign Out
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

SignOutConfirmation.displayName = "SignOutConfirmation" as const
